// eslint-disable-next-line
// @ts-ignore
export const nonceTemplate = document.head.querySelector('meta[name=nonce]')?.['content'];
